interface Props {
  type: string;
  placeholder: string;
  name: string;
  required: boolean;
}

const Input = ({ type, placeholder, name, required }: Props) => {
  return (
    <input
      required={required}
      type={type}
      name={name}
      className="wt-body-font block w-full rounded-wt border-2 border-gray-200 bg-white px-5 py-2 text-base font-light text-black placeholder-gray-400 shadow-md focus:border-2 focus:border-wt-primary focus:outline-none sm:shadow-none"
      placeholder={placeholder}
    />
  );
};

export default Input;
